import { z } from 'zod';

export const performSqlQueryRequest = z.object({
  body: z.object({}).optional(),
  query: z.object({
    projectId: z.string().min(1, 'Project ID is required'),
    query: z.string().min(1, 'Query is required'),
    token: z.string(),
  }),
  params: z.object({}).optional(),
});
export type PerformSqlQueryRequest = z.infer<typeof performSqlQueryRequest>;
export type PerformSqlQueryResponse = {
  result: string;
};

export const getPipesRequest = z.object({
  body: z.object({}).optional(),
  query: z.object({
    projectId: z.string().min(1, 'Project ID is required'),
  }),
  params: z.object({}).optional(),
});
export type GetPipesRequest = z.infer<typeof getPipesRequest>;
export type GetPipesResponse = {
  result: DatasourceInfo[];
};

export const getDatasourcesRequest = z.object({
  body: z.object({}).optional(),
  query: z.object({
    projectId: z.string().min(1, 'Project ID is required'),
  }),
  params: z.object({}).optional(),
});
export type GetDatasourcesRequest = z.infer<typeof getPipesRequest>;

export type DatasourceInfo = {
  name: string;
  columns: {
    name: string;
    type: string;
  }[];
  description: string;
};

export type GetDatasourcesResponse = {
  result: DatasourceInfo[];
};

export const getRetentionQueryRequest = z.object({
  body: z.object({}).optional(),
  query: z.object({
    projectId: z.string().min(1, 'Project ID is required'),
    filterKey: z.enum(['anonymous_id', 'address']),
  }),
  params: z.object({}).optional(),
});

export type GetRetentionQueryRequest = z.infer<typeof getRetentionQueryRequest>;

export type GetRetentionQueryResponse = {
  result: string;
};

export const performChatQueryRequest = z.object({
  body: z.object({
    messages: z.array(
      z.object({
        role: z.enum(['user', 'assistant', 'system']),
        content: z.string(),
        id: z.string().optional(),
      }),
    ),
  }),
  query: z.object({}).optional(),
  params: z.object({}).optional(),
  headers: z
    .object({
      'x-project-id': z.string().min(1, 'Project ID is required'),
      authorization: z.string().optional(),
    })
    .optional(),
});

export type PerformChatQueryRequest = z.infer<typeof performChatQueryRequest>;

export type PerformChatQueryResponse = {
  // This endpoint streams the response, so no traditional JSON response structure
  // The response is streamed directly to the HTTP response
};
